import React from "react";
import ReactDOM from "react-dom/client";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

// Check if the page was pre-rendered by react-snap
const hasChildNodes = rootElement.hasChildNodes();

if (hasChildNodes) {
  // Hydrate pre-rendered content (for SEO)
  hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // Normal render for development
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
